<div class="doc-code-block" *ngIf="!loading && !error; else statusTpl">
  <div class="doc-code-block__toolbar">
    <span class="doc-code-block__label">{{ title || (language || 'code') }}</span>
    <button
      type="button"
      class="doc-code-block__copy"
      [class.doc-code-block__copy--copied]="copyFeedback === 'copied'"
      (click)="copy()"
      [disabled]="!rawCode"
      [attr.aria-label]="copyFeedback === 'copied' ? 'Copiado' : 'Copiar código'"
      [attr.title]="copyFeedback === 'copied' ? 'Copiado' : 'Copiar'">
      <ng-container *ngIf="copyFeedback === 'idle'">
        <mat-icon aria-hidden="true">content_copy</mat-icon>
      </ng-container>
      <ng-container *ngIf="copyFeedback === 'copied'">
        <mat-icon class="doc-code-block__copy-check" aria-hidden="true">check</mat-icon>
        <span class="doc-code-block__copy-text">Copiado</span>
      </ng-container>
    </button>
  </div>
  <pre
    *ngIf="highlighted"
    class="doc-code-block__pre"
    [ngClass]="'language-' + prismLanguage">
    <code [ngClass]="'language-' + prismLanguage" [innerHTML]="highlighted"></code>
  </pre>
</div>

<ng-template #statusTpl>
  <div class="doc-code-block doc-code-block--status" *ngIf="loading">Cargando snippet…</div>
  <div class="doc-code-block doc-code-block--status doc-code-block--error" *ngIf="error">{{ error }}</div>
</ng-template>
